import { BODY_CONTENT, CONTENT } from '@opengov/stories-shared/constants';
import { IMergeTag } from '@opengov/stories-shared/types';

import React, { useCallback, useMemo, useState } from 'react';
import type { Editor as TinyMCE } from 'tinymce/tinymce';
import {
  createMergeTagHtml,
  MAX_NUMBER_OF_MERGE_TAGS,
  useMergeTagsContext
} from '../../../../../../common/context/MergeTagsContext';
import { EditorCommand } from '../../../../CurrentEditorContext';
import { MergeTagsDropdown } from '../MergeTagsDropdown';
import { ITinyMCEEditorProps, TinyMCEEditor } from '../TinyMCEEditor';

export interface IEditableDivProps {
  editorProps: ITinyMCEEditorProps;
}

export const EditableDiv = ({ editorProps, ...restProps }: IEditableDivProps) => {
  const { mergeTagList, storyMergeTagList } = useMergeTagsContext();
  const [relatedEditor, setRelatedEditor] = useState<TinyMCE | null>(null);
  const isSectionContent = useMemo(
    () => editorProps.storyContent.type === BODY_CONTENT || editorProps.storyContent.type === CONTENT,
    [editorProps.storyContent.content]
  );
  const mergeTagsDropdownDisabled = !relatedEditor || storyMergeTagList.length >= MAX_NUMBER_OF_MERGE_TAGS;
  const mergeTagsDropdownDisabledTooltip = storyMergeTagList.length >= MAX_NUMBER_OF_MERGE_TAGS
    ? editorProps.messages.maxNumberOfFields
    : undefined;

  const onDropdownClick = useCallback(
    (mergeTag: IMergeTag) => {
      relatedEditor?.execCommand(EditorCommand.MceInsertContent, false, createMergeTagHtml(mergeTag));
    },
    [relatedEditor]
  );
  return (
    <>
      <div {...restProps}>
        <TinyMCEEditor {...editorProps} onInit={setRelatedEditor} />
      </div>
      {isSectionContent && mergeTagList.length > 0 ? (
        <div className="editable-tools">
          <MergeTagsDropdown
            mergeTagList={mergeTagList}
            disabled={mergeTagsDropdownDisabled}
            disabledTooltipText={mergeTagsDropdownDisabledTooltip}
            onClick={onDropdownClick}
          />
        </div>
      ) : null}
    </>
  );
};
